module.exports = __webpack_public_path__ + "static/img/case_banner_14_h5.f42cf6f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/case/case_banner_14_h5.png
// module id = 5dS8
// module chunks = 34